import { dataHooks } from '@wix/data-hooks';

export const fulfillmentSectionDataHooks = dataHooks<{
  root: {};
}>('fulfillment-section');
